<template>
  <!-- eslint-disable vue/no-v-html -->
  <div
    v-if="hasHtml && cleanedContent"
    v-html="cleanedContent"
  />
  <component
    :is="tag"
    v-else-if="!hasHtml && (cleanedContent || $slots.default)"
  >
    <slot>{{ cleanedContent }}</slot>
  </component>
</template>

<script setup lang="ts">

const props = defineProps({
  content: {
    type: String,
    required: false,
    default: null,
    validator: (value: string) => value.length > 0
  },
  tag: {
    type: String,
    required: false,
    default: 'p'
  },
  allowedHtmlTag: {
    type: String,
    required: false,
    default: null
  }
});

const cleanedContent = computed(() => {
  if (!props.allowedHtmlTag) {
    return props.content;
  }

  // Convert the comma-separated allowed tags into a regular expression
  const allowedTagsArray = props.allowedHtmlTag.split(',');
  const allowedTagsPattern = `^(${allowedTagsArray.join('|')})$`;
  const allowedTags = new RegExp(allowedTagsPattern, 'i');

  const tagRegex = /<\/?(\w+)[^>]*>/g;

  return props.content
    ? props.content.replace(tagRegex, function (tag) {
      const tagNameMatch = tag.match(/<\/?(\w+)[^>]*>/);
      const tagName = tagNameMatch ? tagNameMatch[1] : null;
      if (tagName && allowedTags.test(tagName)) {
        return tag;
      } else {
        return '';
      }
    })
    : '';
});

const hasHtml = computed(() => {
  const regex = /<[^>]*>/; // This regex checks for HTML tags

  return regex.test(props.content);
});
</script>
